import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notificationTimeLine',
})
export class NotificationTimelinePipe implements PipeTransform {
  transform(startDate: string): string {
    const differenceEnMillisecondes = new Date().getTime() - new Date(startDate).getTime();
    const differenceEnHeures = differenceEnMillisecondes / (1000 * 60 * 60);
    if (Math.round(differenceEnHeures) < 1) {
      return `il y a ${Math.round(differenceEnHeures * 60)} minutes`;
    } else if (Math.round(differenceEnHeures) < 24) {
      return `il y a ${Math.round(differenceEnHeures)} heures`;
    } else if (Math.round(differenceEnHeures) === 24) {
      return `il y a 1 jour`;
    } else if (differenceEnHeures / 24 > 1 && differenceEnHeures / 24 <= 30) {
      return `il y a ${Math.round(differenceEnHeures / 24)} jours`;
    } else {
      return `il y a ${Math.round(differenceEnHeures / 24 / 30)} mois`;
    }
  }
}
